import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { screenNameForStatus } from "./statusMeta";

// The project-selection contract (same payload as the legacy list pages).
// LayoutProject/ProjectSidebar resolve state.id into Redux currentProjectId,
// so this shape must stay intact.
//
// Opening a project lands on the project VIEW screen (/pms/project/view/:id),
// not the dashboard. The id rides in the URL as well as in state, so a hard
// refresh or a pasted link still resolves the project (LayoutProject reads the
// trailing numeric segment); state carries the name/lock/status the URL can't.
export const useOpenProject = () => {
  const navigate = useNavigate();
  const { data: currentUser } = useSelector((state: any) => state.currentUser);

  return (record: any) => {
    let allowEdit = true;
    if (record?.lock) {
      if (record?.lockedBy != currentUser?.id) allowEdit = false;
    }
    navigate(
      record?.projectId
        ? `/pms/project/view/${record.projectId}`
        : "/pms/project/view",
      {
        state: {
          id: record?.projectId,
          derivedProjectStatus: record?.derivedProjectStatus,
          projectName: record?.projectTitle,
          extra: {
            screenName: screenNameForStatus(record?.projectStatus),
            lock: record?.lock,
            allowEdit,
            lockedOn: record?.updatedAt
              ? dayjs(record?.updatedAt).format("DD-MMM-YYYY")
              : dayjs(record?.createdAt).format("DD-MMM-YYYY"),
            currentUserId: currentUser?.id,
            lockedBy: record?.lockedBy,
            lockedByUserName: record?.lockedByUserName || "N/A",
            plannedStartDate: record?.plannedStartDate,
            plannedEndDate: record?.plannedEndDate,
            siteId: record?.siteId,
            siteName: record?.siteName,
          },
        },
      }
    );
  };
};
